"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonScheduleRows = void 0;
require("@veeam/components/lib/SchedulingMatrix/SchedulingMatrix");
const core_1 = require("../../../core");
const types_1 = require("../types");
const getScheduleArchivableBackupRow_1 = require("./getScheduleArchivableBackupRow");
const matrixDescriptionRenderer_1 = require("./matrixDescriptionRenderer");
const getCommonScheduleRows = (values, texts, rowsVisibility, isScheduleArchive) => {
    return [
        rowsVisibility[types_1.SCHEDULE_ROW.first] && {
            key: types_1.SCHEDULE_ROW.first,
            title: texts.rowFirstMatrixRowTitle,
            description: matrixDescriptionRenderer_1.matrixDescriptionRenderer({
                textEmpty: texts.rowFirstMatrixRowEmptyLabel,
                textRenderer: (count) => core_1.parseTextConfig(texts.rowFirstMatrixRowFilledLabel, { count: `${count}` }),
            }),
        },
        rowsVisibility[types_1.SCHEDULE_ROW.second] && {
            key: types_1.SCHEDULE_ROW.second,
            title: texts.rowSecondMatrixRowTitle,
            description: matrixDescriptionRenderer_1.matrixDescriptionRenderer({
                textEmpty: texts.rowSecondMatrixRowEmptyLabel,
                textRenderer: (count) => core_1.parseTextConfig(texts.rowSecondMatrixRowFilledLabel, { count: `${count}` }),
            }),
        },
        getScheduleArchivableBackupRow_1.getScheduleArchivableBackupRow(values, texts, rowsVisibility[types_1.SCHEDULE_ROW.third], isScheduleArchive),
    ].filter(Boolean);
};
exports.getCommonScheduleRows = getCommonScheduleRows;
//# sourceMappingURL=getCommonScheduleRows.js.map